module.exports = __webpack_public_path__ + "static/media/salesIco_Selected.5769e5cc.svg";